import { useEffect } from 'react'
import { Empty, FormControl } from '../../../../components/FormUtilities'
import Option from '../../../../components/Option'
import SelectTouch from '../../../../components/SelectTouch'
import { MoneyProps } from './types'

export default function MoneyField({
    option,
    setOption,
    helper,
    optionCompany,
    currencies
}: MoneyProps) {
    useEffect(() => {
        setOption(null)
    }, [optionCompany])

    return (
        <FormControl label="Moneda" required className="mb-2">
            <SelectTouch
                placeholder="Seleccionar moneda"
                option={option}
                onChange={setOption}
                helper={helper}
            >
                {currencies.map(currency => (
                    <Option
                        key={currency.id}
                        label={`${currency.name} (${currency.symbol})`}
                        value={currency.id.toString()}
                    />
                ))}
                <Empty data={currencies} />
            </SelectTouch>
        </FormControl>
    )
}
